module.exports = __webpack_public_path__ + "static/media/filter.a2c1a078.svg";